// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"Modal_closeBtn__37kTv"};